import React, { useRef, useState } from "react";
import { PiSmileyFill } from "react-icons/pi";

import { createComment, createReply } from "../../api";

import ToastMessage from "../ToastMessage";
import PostButton from "../PostButton";
import EmojiReactPicker from "../EmojiReactPicker";

const TextComposer = ({ mode, postId, postType, type, comment, close, closeReply }) => {
  const [text, setText] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const smileyRef = useRef(null);
  const isReply = mode === "reply";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isReply && !comment?.id) {
      ToastMessage("Comment ID is missing.");
      return;
    }

    if (!text.trim()) {
      ToastMessage(isReply ? "Please write a reply." : "Please write something before commenting.");
      return;
    }

    if (isSubmitting) return;

    const formData = new FormData();

    formData.append("type", isReply ? type : postType);

    if (isReply) formData.append("comment_id", comment.id);
    else formData.append("post_id", postId);

    formData.append("content", text.trim());

    try {
      setIsSubmitting(true);

      const res = isReply ? await createReply(formData) : await createComment(formData);

      if (res?.data?.message) {
        ToastMessage(res.data.message);
        setText("");

        if (isReply) closeReply?.();
        else close?.();
      }
    } catch (error) {
      console.error(isReply ? "Reply error:" : "Comment error:", error);
      console.error(error?.response?.data);

      ToastMessage(error?.response?.data?.message || (isReply ? "Failed to send reply." : "Error creating comment."));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="relative rounded-2xl border border-gray-200 bg-white focus-within:border-purple-300 focus-within:ring-4 focus-within:ring-purple-50">
        <label htmlFor={isReply ? "reply" : "comment"} className="sr-only">
          {isReply ? "Your reply" : "Your comment"}
        </label>

        <textarea
          id={isReply ? "reply" : "comment"}
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={5}
          placeholder={isReply ? "Write your reply..." : "Write your comment..."}
          className="w-full resize-none rounded-2xl border-none bg-white px-4 py-4 pr-12 text-sm font-medium text-gray-900 outline-none focus:ring-0"
          required
        />

        {/* Emoji */}
        <button
          ref={smileyRef}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setShowEmoji((prev) => !prev);
          }}
          className="absolute bottom-3 right-3 text-gray-400 transition-colors hover:text-purple-600"
        >
          <PiSmileyFill size={20} />
        </button>

        <EmojiReactPicker set={setText} showEmoji={showEmoji} setShowEmoji={setShowEmoji} triggerRef={smileyRef} />
      </div>

      {text.trim() && (
        <div className="mt-4">
          <PostButton type="submit" text={isSubmitting ? "Sending..." : isReply ? "Reply" : undefined} disabled={isSubmitting} />
        </div>
      )}
    </form>
  );
};

export default TextComposer;